import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Header from 'components/Header';
import OptionsTab from 'components/OptionsTab';
import Container from '@mui/material/Container';
import LocationCards from 'components/LocationCards';
import React from 'react';
import './App.css';
import Footer from 'components/Footer';
import FooterMenu from 'components/FooterMenu';
import { displayOnDesktop } from 'themes/commonStyles';
import MobileFooter from 'components/MobileFooter';
import BeforeFooter from './components/BeforeFooter.js';
import SearchMainComp from './components/SearchMainComp.js';
import DetailsThingComp from './components/DetailsThingComp.js';
import MapComp from './components/MapComp.js';
import DetailsReviewComp from './components/DetailsReviewComp.js';
import DetailsHostedComp from './components/DetailsHostedComp.js';
import DetailsImgComp from './components/DetailsImgComp.js'
import {Route,BrowserRouter as Router,Routes} from 'react-router-dom';
import MainPage from './Pages/MainPage.js';
import DetailsPage from './Pages/DetailsPage.js';
import FilterPage from './Pages/FilterPage.js';

function App() {

  return (
    <Router>
      <Routes>
      <Route path='/' element={<MainPage/>} />
      <Route path='/details' element={<DetailsPage/>} />
      <Route path='/filter' element={<FilterPage/>} />
      </Routes>
    </Router>

  );
}

export default App;

{/* <Switch>
<Route path='/'>
  <MainPage/>
  </Route>
<Route path='/details'>
  <DetailsPage/>
  </Route>
<Route path='/filter' >
  <FilterPage/>
  </Route>
</Switch> */}

// <React.Fragment>
// <CssBaseline />
// <Box
//   sx={{
//     display: 'flex',
//     flexDirection: 'column',
//     height: '100vh',
//   }}
// >
//   <Box>
//     <Header />
//     {/* <OptionsTab /> */}
//   </Box>
//   <Box
//     sx={{
//       display: 'flex',
//       flexDirection: 'column',
//       flexGrow: 1,
//       width:'100%',
//       height: 100,
//       overflowY: 'scroll'
//     }}
//   >
//     <Container style={{minWidth:'100%'}} sx={{ mb: 0,ml:0,mr:0 }}>
//       {/* <LocationCards /> */}
//       {/* <SearchMainComp/> */}
//       {/* <BeforeFooter/> */}
//       {/* <MapComp/> */}
//       {/* <DetailsReviewComp/> */}
//       {/* <DetailsThingComp/> */}
//       {/* <DetailsHostedComp/> */}
//       <DetailsImgComp/>
//       <Box
//         sx={{
//           display: { xs: 'flex', md: 'none' },
//         }}
//       >
//         <MobileFooter />
//       </Box>
//     </Container>
//   </Box>
//   <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
//     <FooterMenu />
//   </Box>
//   <Box sx={displayOnDesktop}>
//     {/* <Footer /> */}
//   </Box>
// </Box>
// </React.Fragment>